module.exports = __webpack_public_path__ + "static/media/mmBadge2025.90beb01a.png";